const { useState } = require("react");

export const useStateArr = (defaultValue = []) => {
  const [state, setState] = useState(defaultValue || []);
  const add = (elem) => setState([...state, elem]);
  const remove = (elem) => setState(state.filter((item) => item !== elem));
  return [state, setState, add, remove];
};
